"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoSourceMapper = void 0;
var enum_mapper_1 = require("../utils/enum-mapper");
var globalTypes_1 = require("../private/generated/globalTypes");
var video_sources_1 = require("@wix/wix-vod-constants/dist/common/video-sources");
exports.videoSourceMapper = new enum_mapper_1.EnumMapper((_a = {},
    _a[globalTypes_1.VideoSource.COMPUTER] = video_sources_1.VIDEO_SOURCES.COMPUTER,
    _a[globalTypes_1.VideoSource.YOUTUBE] = video_sources_1.VIDEO_SOURCES.YOUTUBE,
    _a[globalTypes_1.VideoSource.FACEBOOK] = video_sources_1.VIDEO_SOURCES.FACEBOOK,
    _a[globalTypes_1.VideoSource.VIMEO] = video_sources_1.VIDEO_SOURCES.VIMEO,
    _a[globalTypes_1.VideoSource.LIVE] = video_sources_1.VIDEO_SOURCES.LIVE,
    _a[globalTypes_1.VideoSource.GOOGLE_DRIVE] = video_sources_1.VIDEO_SOURCES.GOOGLE_DRIVE,
    _a[globalTypes_1.VideoSource.DROPBOX] = video_sources_1.VIDEO_SOURCES.DROPBOX,
    _a));
//# sourceMappingURL=video-source.js.map